import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import { ClassNameMap } from '@mui/styles/withStyles'
import { Routes } from 'common/routeConfig'
import MailTo from 'components/mailTo/mailTo'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import StaticPageTypography from './StaticPageTypography'

type ContactAndButtonBlockProps = {
    styles: ClassNameMap
    isLargeScreen: boolean
    withHomeButton?: boolean
    withContact?: boolean
}

const ContactAndButtonBlock = ({
    styles,
    isLargeScreen,
    withContact,
    withHomeButton
}: ContactAndButtonBlockProps) => {
    const { t } = useTranslation('common')
    const navigate = useNavigate()

    const handleHomeClick = () => {
        navigate(Routes.BASE)
        window.location.reload()
    }
    return (
        <>
            {withHomeButton && (
                <Button
                    className={styles.goBackButton}
                    variant="contained"
                    onClick={handleHomeClick}
                >
                    {t('buttons.goBackHome')}
                </Button>
            )}
            {withContact && (
                <Box>
                    <StaticPageTypography
                        component="div"
                        variant={isLargeScreen ? 'body2' : 'caption'}
                    >
                        <Trans i18nKey="common:contact.haveQuestions">
                            If you have any questions
                        </Trans>
                        {', '}
                        <Trans i18nKey="common:contact.contactUsAnyTime">
                            please feel free to contact us any time at
                        </Trans>{' '}
                        <MailTo
                            email="support@genomate.health"
                            typographyProps={{
                                className: styles.emailLink,
                                variant: isLargeScreen ? 'body2' : 'caption'
                            }}
                        />
                    </StaticPageTypography>
                </Box>
            )}
        </>
    )
}

export default ContactAndButtonBlock
